"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../data/constants");
var MetaThemeColor = /** @class */ (function () {
    function MetaThemeColor() {
        this.firstSection = document.querySelector("[".concat(constants_1.DATA_MAIN, "]")).firstElementChild;
        if (!this.firstSection) {
            return;
        }
        this.firstSectionBackgroundColor = window.getComputedStyle(this.firstSection).backgroundColor;
        var hexColor = this.rgbToHex(this.firstSectionBackgroundColor);
        var themeColorMetaTag = document.querySelector('meta[name="theme-color"]');
        themeColorMetaTag.setAttribute('content', hexColor);
    }
    // Utility function to convert rgb to hex
    MetaThemeColor.prototype.rgbToHex = function (rgb) {
        var rgbValues = rgb.match(/\d+/g); // Extract numbers
        if (!rgbValues || rgbValues.length < 3) {
            return '#b8d898'; // Default fallback
        }
        var _a = rgbValues.map(Number), r = _a[0], g = _a[1], b = _a[2]; // Convert to numbers
        return "#".concat(((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase());
    };
    return MetaThemeColor;
}());
exports.default = MetaThemeColor;
